import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, Globe, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

function tl(n, fmt) {
    if (fmt) return fmt;
    if (n == null || n === "") return "—";
    const v = Number(n);
    if (!Number.isFinite(v)) return "—";
    return `₺${Math.round(v).toLocaleString("tr-TR")}`;
}

export default function EhmStickyOzet({
    seciliDosya,
    ucgen,
    loading,
    parcaTarama,
    onTamAnaliz,
    onSunum,
}) {
    if (!seciliDosya && !ucgen) return null;

    return (
        <div className="sticky top-0 z-20 -mx-6 px-6 py-3 mb-4 border-b border-[#D4AF37]/20 bg-[#0a0e14]/95 backdrop-blur-md">
            <div className="max-w-[90rem] mx-auto flex flex-wrap items-center gap-3">
                <div className="min-w-0 flex-1">
                    <div className="text-[10px] uppercase tracking-wider text-slate-500">Dosya özeti</div>
                    <div className="text-sm text-white font-medium truncate">
                        {seciliDosya ? (
                            <>
                                <Link
                                    to={seciliDosya.link || `/e/sigorta-dosyalari/${seciliDosya.id}`}
                                    className="text-[#D4AF37] hover:underline"
                                >
                                    {seciliDosya.dosya_no}
                                </Link>
                                {seciliDosya.plaka ? (
                                    <span className="text-slate-500 ml-2">{seciliDosya.plaka}</span>
                                ) : null}
                                {seciliDosya.marka ? (
                                    <span className="text-slate-400 ml-2 text-xs">
                                        {seciliDosya.marka} {seciliDosya.model}{" "}
                                        {seciliDosya.model_yili || ""}
                                    </span>
                                ) : null}
                            </>
                        ) : (
                            "—"
                        )}
                    </div>
                </div>
                {ucgen ? (
                    <div className="flex flex-wrap gap-4 text-xs tabular-nums">
                        <div>
                            <span className="text-slate-500 block">Ekspertiz</span>
                            <span className="text-white">{tl(ucgen.ekspertiz_toplam, ucgen.ekspertiz_toplam_fmt)}</span>
                        </div>
                        <div>
                            <span className="text-slate-500 block">Fatura</span>
                            <span className="text-emerald-300">{tl(ucgen.fatura_toplam, ucgen.fatura_toplam_fmt)}</span>
                        </div>
                        <div>
                            <span className="text-slate-500 block">Uyumluluk</span>
                            <span className="text-emerald-300">%{ucgen.uyumluluk_skoru ?? "—"}</span>
                        </div>
                    </div>
                ) : null}
                <div className="flex flex-wrap gap-2">
                    <Button size="sm" className="bg-violet-600 hover:bg-violet-700 h-8" onClick={onTamAnaliz} disabled={loading || parcaTarama}>
                        {parcaTarama ? <Loader2 className="h-3.5 w-3.5 animate-spin mr-1" /> : <Globe className="h-3.5 w-3.5 mr-1" />}
                        Tam analiz
                    </Button>
                    {seciliDosya ? (
                        <Link
                            to={`/yeni/deger-kaybi-gelismis?dosya=${seciliDosya.id}&ekspertiz=1`}
                            className="inline-flex items-center h-8 px-3 rounded-md text-xs border border-emerald-500/40 text-emerald-200 hover:bg-emerald-500/10"
                        >
                            Gelişmiş DK →
                        </Link>
                    ) : null}
                    <Button size="sm" variant="outline" className="h-8" onClick={onSunum} disabled={loading}>
                        <BookOpen className="h-3.5 w-3.5 mr-1" />
                        Sunum
                    </Button>
                </div>
            </div>
        </div>
    );
}
